<template>
  <a
    class="relative min-h-[420px] h-[420px] hover:no-underline"
    :href="`/school/course/${course.id}`"
  >
    <li
      class="relative h-full overflow-hidden rounded-[18px] border border-gray-200 bg-white list-none"
    >
      <div class="LessonCard__cover">
        <cover-image :src="course.image" class="b-rad-t-lg flex flex-center"></cover-image>
      </div>

      <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
        <div class="flex justify-between gap-x-4 py-3">
          <h2 class="text-gray-600 text-lg font-medium capitalize">{{ course.name }}</h2>
        </div>
      </dl>

      <dl
        class="absolute w-full bottom-2 -my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6"
      >
        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500 font-medium">Created</dt>
          <dd class="text-gray-700">
            <time :datetime="course.created_at">{{ getDate(course.created_at) }}</time>
          </dd>
        </div>
        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500 font-medium">
            Total Slides: {{ course.course_slide.length }}
          </dt>
          <dd class="flex items-start gap-x-2">
            <div
              v-if="!course.course_user_entry"
              class="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/20"
            >
              Not Started
            </div>
            <div
              v-else-if="course.course_user_entry && course.course_user_entry.passed && course.course_user_entry.finished_at"
              class="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20"
            >
              Passed
            </div>
            <div
              v-else-if="course.course_user_entry && !course.course_user_entry.passed && !course.course_user_entry.finished_at"
              class="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/20"
            >
              In Progress
            </div>
            <div
              v-else-if="course.course_user_entry && course.course_user_entry.finished_at"
              class="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/20"
            >
              Failed to Finish
            </div>
          </dd>
        </div>
      </dl>
    </li>
  </a>
</template>

<script type="text/babel">
export default {
  props: ["course"],
  methods: {
    getDate(timestamp) {
      return moment(timestamp).format("D. MMM. YYYY");
    },
  },
};
</script>
